import React, { FC } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import { Person } from '@mui/icons-material';
import ReviewWrapper from '../ReviewWrapper';
import ReviewText from '../ReviewText';
import DataShakeSummary from '../DataShakeSummary';

interface Props extends IReviewNewProps {}

const IdealoReview: FC<Props> = ({
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { username, header, text, rating } = reviewEntry.review;
  return (
    <ReviewWrapper
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={true}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      <DataShakeSummary reviewEntry={reviewEntry} />
    </ReviewWrapper>
  );
};

export default IdealoReview;
